import { PriorityFeedCapabilityConfiguration } from 'capability-ng-priority-feed';
import { ApplicationConfiguration } from '../../models/app_config_model';
import { AppointmentSchedulingConfiguration } from 'capability-ng-appointments';
import { MajorExplorerCapabilityConfiguration } from 'capability-ng-major-explorer';
import { FavoriteCapabilityConfiguration } from 'capability-ng-favorites';
import { CourseScheduleCapabilityConfiguration } from 'capability-ng-course-schedule';
import { ConversationsCapabilityConfiguration } from 'capability-ng-conversations';
import { StudyGroupsCapabilityConfiguration } from 'capability-ng-study-groups';
import { EmailManagementService } from './email_management_service';
import { SettingsCapabilityConfiguration } from 'capability-ng-settings';
import { PollCapabilityConfiguration } from 'capability-ng-poll';

export class CapabilityConfigurationService {
  constructor(
    private appConfigModel: ApplicationConfiguration,
    private ngEmailManagementService: EmailManagementService,
    private DefaultRoute: string,
    private FEATURE_HOLDS: string,
    private FEATURE_NOTIFICATIONS: string,
    private FEATURE_PERSONAL_REMINDERS: string,
    private FEATURE_MAJOR_EXPLORER: string,
    private FEATURE_RESOURCES: string,
    private FEATURE_CONNECT: string,
    private FEATURE_APPOINTMENTS: string,
    private FEATURE_STUDY_BUDDIES: string,
    private FEATURE_SHOW_STUDENT_NK: string,
    private FEATURE_SELF_ALERT: string,
    private FEATURE_TODOS: string,
    private FEATURE_STUDENT_FEEDBACK: string,
    private ngPriorityFeedCapabilityConfiguration: PriorityFeedCapabilityConfiguration,
    private ngMajorExplorerCapabilityConfiguration: MajorExplorerCapabilityConfiguration,
    private ngFavoriteCapabilityConfiguration: FavoriteCapabilityConfiguration,
    private ngConversationsCapabilityConfiguration: ConversationsCapabilityConfiguration,
    private ngCourseScheduleCapabilityConfiguration: CourseScheduleCapabilityConfiguration,
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration,
    private ngStudyGroupsCapabilityConfiguration: StudyGroupsCapabilityConfiguration,
    private ngSettingsCapabilityConfiguration: SettingsCapabilityConfiguration,
    private ngPollCapabilityConfiguration: PollCapabilityConfiguration
  ) {}

  configure() {
    this.configurePriorityFeed();
    this.configureMajorExplorer();
    this.configureFavorites();
    this.configureCourseSchedule();
    this.configureConversations();
    this.configureAppointments();
    this.configureStudyGroups();
    this.configureSettings();
    this.configurePoll();
    this.configureReports();
  }

  configurePriorityFeed(): void {
    this.ngPriorityFeedCapabilityConfiguration.setConfigs({
      isMobile: false,
      isReminderEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_PERSONAL_REMINDERS),
      isHoldEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_HOLDS),
      isNotificationsEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_NOTIFICATIONS),
      isAppointmentEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_APPOINTMENTS),
      isStudyGroupEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_STUDY_BUDDIES),
      isSelfAlertEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_SELF_ALERT),
      isTodosEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_TODOS),
      isStudentFeedbackEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_STUDENT_FEEDBACK),
      institutionMediaURL: this.appConfigModel.getInstitutionMediaPath('reg_dashboard'),
      isKnowledgeBotEnabled: this.appConfigModel.isFeatureEnabled('core-knowledge_bot')
    });
  }

  configureMajorExplorer(): void {
    this.ngMajorExplorerCapabilityConfiguration.config = {
      isMobile: false,
      devReqStrategy: this.appConfigModel.getConfigProperty('cat-devreq_assignment_strategy'),
      navIconTheme: this.appConfigModel.navIconTheme()
    };
  }

  configureFavorites(): void {
    this.ngFavoriteCapabilityConfiguration.config = {
      isMajorExplorerEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_MAJOR_EXPLORER),
      isResourcesEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_RESOURCES)
    };
  }

  configureCourseSchedule(): void {
    this.ngCourseScheduleCapabilityConfiguration.config = {
      isMobile: false,
      navIconTheme: this.appConfigModel.navIconTheme()
    };
  }

  configureConversations(): void {
    this.ngConversationsCapabilityConfiguration.config = {
      isMobile: false,
      navIconTheme: this.appConfigModel.navIconTheme(),
      isConnectEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_CONNECT)
    };
  }

  configureAppointments(): void {
    this.ngAppointmentSchedulingConfiguration.config = {
      isMobile: false,
      notificationHandle: 'app-alerts'
    };
  }

  configureStudyGroups(): void {
    this.ngStudyGroupsCapabilityConfiguration.config = {
      isMobile: false,
      emailService: this.ngEmailManagementService,
      notificationHandle: 'app-alerts'
    };
  }

  configureSettings(): void {
    this.ngSettingsCapabilityConfiguration.config = {
      isMobile: false,
      hasIntakePoll: this.appConfigModel.useIntakePoll(),
      hasFirstTerm: this.appConfigModel.useFirstTermPoll(),
      institutionMediaPath: this.appConfigModel.getInstitutionMediaPath('core_mobile_school_logo'),
      isStudentNKCardEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_SHOW_STUDENT_NK)
    };
  }

  configurePoll(): void {
    this.ngPollCapabilityConfiguration.config = {
      isMobile: false,
      hasIntakePoll: this.appConfigModel.useIntakePoll(),
      hasFirstTerm: this.appConfigModel.useFirstTermPoll(),
      intakeOrFirstTermID: this.appConfigModel.intakeOrFirstTermID(),
      defaultRoute: this.DefaultRoute
    };
  }

  configureReports(): void {
    localStorage.setItem(
      'eab.navigate.self_alert_create',
      this.appConfigModel.model.member_features['ssccampus-self_alert_create'].toString()
    );
  }
}



// WEBPACK FOOTER //
// ./app/lib/core/services/capability_configuration_service.ts